import { css } from 'lit';

export const formCss = css`
  label {
    display: block;
    font-weight: bold;
  }

  input {
    display: block;
    background: #f8f8f8;
    border: 1px solid black;
    border-radius: 4px;
    padding: 0.125em 0.25em;
  }

  .visually-hidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .puzzle-input {
    font-size: 2rem;
    letter-spacing: 0.2rem;
    width: 15ch;
  }
`;
